/**
 * Checkout consent wording from the store's real terms (MERCH-53): the sfSeller feed
 * (lib/store/seller) carries the platform return window and the store's policy versions.
 * Returns null until the terms are loaded, so the shopper never consents to unseen terms.
 */
export function consentLabel(seller) {
  const p = seller && seller.policies;
  if (!p || !p.returns) return null;
  const tag = (v) => (v ? ` (${v})` : '');
  const days = Number.isInteger(p.returns.return_days) ? p.returns.return_days : null;
  const returns = days > 0 ? `${days}-day return policy${tag(p.returns.version)}` : `return policy${tag(p.returns.version)}`;
  const warranty = `warranty terms${tag(p.warranty && p.warranty.version)}`;
  return `I accept the seller's ${returns} and ${warranty}, and confirm the condition shown in each inspection passport.`;
}

/**
 * The return window as a short label, from the sfSeller feed (MERCH-53): "14-day returns",
 * "Warranty claims" when the policy gives no change-of-mind window, and "Returns" (no number)
 * until the terms are loaded. No number is ever assumed.
 */
export function returnsLabel(seller, listing) {
  // A window by product type (MERCH-88, listing.return_policy) wins over the store-wide one.
  const own = listing && listing.return_policy;
  if (own && Number.isInteger(own.return_days)) return own.return_days > 0 ? `${own.return_days}-day returns` : 'No returns';
  const p = seller && seller.policies;
  const days = p && p.returns && Number.isInteger(p.returns.return_days) ? p.returns.return_days : null;
  if (days == null) return 'Returns';
  return days > 0 ? `${days}-day returns` : 'Warranty claims';
}

/**
 * The exchange window of a listing's type (MERCH-88, listing.return_policy.exchange_days): "7-day exchange",
 * or null when its type has none (electronics listings carry no return_policy).
 */
export function exchangeLabel(listing) {
  const own = listing && listing.return_policy;
  return own && Number.isInteger(own.exchange_days) && own.exchange_days > 0 ? `${own.exchange_days}-day exchange` : null;
}

/** "Return within 7 days of delivery, or exchange within 7 days." from a listing type's windows (MERCH-88). */
export function typeWindowsText(w) {
  const parts = [w.return_days > 0 ? `Return within ${w.return_days} days of delivery` : 'No change-of-mind returns', w.exchange_days > 0 ? `exchange within ${w.exchange_days} days` : null].filter(Boolean);
  return `${parts.join(', or ')}.`;
}
